import React, { Component, } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import './styles.css'

class DefaultMarker extends Component {
  static propTypes = {
    marker: PropTypes.shape({
      duration: PropTypes.shape({
        days: PropTypes.number,
      }),
    }).isRequired,
  }

  state = {
    hovering: false,
  }

  onMouseOver = () => {
    this.setState({
      hovering: true,
    })
  }

  onMouseOut = () => {
    this.setState({
      hovering: false,
    })
  }

  render() {
    const pulse = this.state.hovering
      ? <div className="default-marker__point--pulse" />
      : <div className="default-marker__point" />
    const counter = this.props.marker.duration
      ? this.props.marker.duration.days
      : ''
    const markerClass = classNames(
      'default-marker__pin default-marker__pin--bounce',
      {
        'default-marker__pin--dot': !this.props.marker.duration,
      }
    )
    return (
      <div
        className="default-marker__container"
        onMouseOver={this.onMouseOver}
        onMouseOut={this.onMouseOut}
        role="presentation"
      >
        <div className="default-marker__pin default-marker__pin--bounce default-marker__pin--background" />
        <div className={markerClass}>
          <div className="default-marker__pin--count">
            <span>
              {counter}
            </span>
          </div>
        </div>
        {pulse}
      </div>
    )
  }
}

export default DefaultMarker



// WEBPACK FOOTER //
// ./src/components/GoogleMaps/Map/DefaultMarker/index.js